import { usePageTitle } from '../hooks/usePageTitle'

const TermsPage = () => {
    usePageTitle('Terms and Conditions | Lynora')
    return (
        <main className="main">
            <div className="container">
                <section className="policy-page">
                    <div className="policy-card">
                        <h1 className="policy-title">Terms and Conditions</h1>
                        <p className="policy-date">Last updated: March 2026</p>

                        <div className="policy-content">
                            <h2>1. Agreement to Terms</h2>
                            <p>
                                By accessing and using Lynora ("the Platform"), you agree to be bound by these Terms and
                                Conditions.
                                If you do not agree to these terms, please do not use our services.
                            </p>

                            <h2>2. Age Requirement</h2>
                            <p>
                                You must be at least 18 years old to use Lynora. By using our platform, you confirm that
                                you meet
                                this age requirement. We reserve the right to verify your age at any time.
                            </p>

                            <h2>3. Virtual Credits System</h2>
                            <p>
                                Lynora operates on a virtual Credits system. Important points about Credits:
                            </p>
                            <ul>
                                <li>Credits are virtual points with no monetary value</li>
                                <li>Credits cannot be exchanged, transferred, or converted to real money</li>
                                <li>Credits cannot be withdrawn or cashed out</li>
                                <li>New users receive starter Credits upon registration</li>
                                <li>Credits are for entertainment purposes only</li>
                            </ul>

                            <h2>4. No Real Money</h2>
                            <p>
                                Lynora is a social gaming platform for entertainment only. There is no real money
                                involved in any
                                aspect of our games. You cannot deposit money, win money, or withdraw money from our
                                platform.
                            </p>

                            <h2>5. User Conduct</h2>
                            <p>
                                When using Lynora, you agree to:
                            </p>
                            <ul>
                                <li>Provide accurate information during registration</li>
                                <li>Not create multiple accounts</li>
                                <li>Not attempt to manipulate or exploit the games</li>
                                <li>Not use automated systems or bots</li>
                                <li>Respect other users and our staff</li>
                            </ul>

                            <h2>6. Account Termination</h2>
                            <p>
                                We reserve the right to suspend or terminate your account if you violate these terms, engage
                                in
                                suspicious activity, or for any other reason at our discretion.
                            </p>

                            <h2>7. Modifications</h2>
                            <p>
                                We may modify these Terms and Conditions at any time. Continued use of the platform after
                                changes
                                constitutes acceptance of the new terms.
                            </p>

                            <h2>8. Disclaimer</h2>
                            <p>
                                Lynora is provided "as is" without warranties of any kind. We are not responsible for
                                any
                                technical issues, data loss, or interruptions in service.
                            </p>

                            <h2>9. Contact</h2>
                            <p>
                                If you have questions about these terms, please contact us at <a
                                    href="/cdn-cgi/l/email-protection" className="__cf_email__"
                                    data-cfemail="2841464e47685b40474d4f49454d5b064b4745">info@lynora.org.</a>.
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    )
}

export default TermsPage